<div id="chartmapdiv" class="fx-flex" style="height:100%"></div>